import { lazy } from 'react'
import { Route } from 'react-router-dom'

const ScoutListPage = lazy(() => import('./ScoutList'))
const ScoutDetailsPage = lazy(() => import('./ScoutDetails'))
const ScoutCreatePage = lazy(() => import('./ScoutCreate'))
const ScoutEditPage = lazy(() => import('./ScoutEdit'))

export const routes = (
  <>
    <Route path="scouts">
      <Route index element={<ScoutListPage />} />
      <Route path="show/:id" element={<ScoutDetailsPage />} />
      <Route path="create" element={<ScoutCreatePage />} />
      <Route path="edit/:id" element={<ScoutEditPage />} />
    </Route>
  </>
)
